export default __webpack_public_path__ + "static/zapier-integration-aac33ad4a96ce7ad4db70750f5356765.webp";